// 必须有这个导入，否则使用路由报错
import Vue from 'vue'
// 导入路由依赖
import VueRouter from 'vue-router'
// 导入两个页面
import FirstPage from "@/pages/FirstPage";
import LoginDl from "@/pages/LoginDl";
// 使用路由
Vue.use(VueRouter);
// 创建路由对象。new VueRouter为上面import设置的名称
const router = new VueRouter({
    // 没有history，访问URL会有#
    mode:"history",
    routes:[
        {
            path:"/login",
            component:FirstPage,
            name:"FirstPage"
        },
        {
            path:"/",
            component:LoginDl,
            name:"LoginDl"
        }
    ]
});
// 必须有这个导出，否则main.js无法获取router对象
export default router